<template>
  <content-items-list
    content-type="trial-reports"
    content-type-singular="trial-report"
    content-name="Trial Reports"
    content-name-singular="Trial Report"
  />
</template>

<script>
import ContentItemsList from '@/views/content-item/content-items-list/ContentItemsList.vue'

export default {
  components: {
    ContentItemsList,
  },
}
</script>

<style scoped>

</style>
